<template>
    <div class="crypto-providers">
        <div class="d-flex flex-column">
            <b-btn
                v-for="cryptoExchange in cryptoExchanges"
                :key="cryptoExchange.slug"
                size="lg"
                pill
                class="crypto-exchange-btn mb-2"
                :style="exchangeStyle(cryptoExchange)"
                @click="openExchange(cryptoExchange)"
            >
                <span class="d-flex align-items-center justify-content-between">
                    <span>
                        {{ cryptoExchange.name }}
                        <b-badge
                            v-if="cryptoExchange.peerToPeer"
                            variant="light"
                            pill
                            class="ml-1 text-dark"
                        >
                            {{ $t("Peer-to-peer") }}
                        </b-badge>
                    </span>
                    <font-awesome-icon
                        icon="fa-light fa-arrow-up-right-from-square"
                    />
                </span>
            </b-btn>
        </div>

        <b-modal
            v-model="peerToPeerModal"
            :title="$t('Before you continue')"
            centered
            ok-variant="warning"
            :ok-title="$t('I understand — continue')"
            :cancel-title="$t('Cancel')"
            @ok="confirmPeerToPeer"
        >
            <div class="small">
                <p class="mb-3">
                    <font-awesome-icon
                        icon="fa-duotone fa-triangle-exclamation"
                        class="text-warning mr-1"
                    />
                    {{
                        $t(
                            "This is a marketplace of individual traders — not a regulated exchange. We don't control or guarantee these trades."
                        )
                    }}
                </p>
                <p class="mb-3">
                    {{
                        $t(
                            "Only trade with people who have a strong track record of successful payouts — a high number of completed trades, a high completion rate, and good reviews. Each trader's history is shown on their profile."
                        )
                    }}
                </p>
                <p class="mb-3">
                    {{
                        $t(
                            "Always keep your crypto in escrow until you have confirmed you received payment, and turn on two-factor authentication."
                        )
                    }}
                </p>
                <p class="mb-0">
                    {{
                        $t(
                            "In many regions this is the fastest, most efficient way to get your cash — it's a valid option, you just have to choose your trader carefully."
                        )
                    }}
                </p>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            cryptoExchanges: [],
            peerToPeerModal: false,
            pendingCryptoExchange: null,
        };
    },
    mounted() {
        this.api.post("/withdraw/cryptoExchanges").then((response) => {
            this.cryptoExchanges = response.data.cryptoExchanges;
        });
    },
    methods: {
        exchangeStyle(cryptoExchange) {
            return {
                backgroundColor: "#" + cryptoExchange.brandColor,
                borderColor: "#" + cryptoExchange.brandColor,
                color: this.readableTextColor(cryptoExchange.brandColor),
            };
        },
        readableTextColor(hex) {
            const r = parseInt(hex.substr(0, 2), 16);
            const g = parseInt(hex.substr(2, 2), 16);
            const b = parseInt(hex.substr(4, 2), 16);

            const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

            return luminance > 0.6 ? "#1a1a1a" : "white";
        },
        openExchange(cryptoExchange) {
            // Peer-to-peer options are not regulated exchanges — intercept the
            // click and make the creator consent to the risks before we send
            // them off. Regulated exchanges open directly.
            if (cryptoExchange.peerToPeer) {
                this.pendingCryptoExchange = cryptoExchange;
                this.peerToPeerModal = true;
                return;
            }

            this.$store.dispatch("system/openBrowser", cryptoExchange.signupUrl);
        },
        confirmPeerToPeer() {
            if (!this.pendingCryptoExchange) {
                return;
            }

            this.$store.dispatch(
                "system/openBrowser",
                this.pendingCryptoExchange.signupUrl
            );
        },
    },
};
</script>

<style scoped>
.crypto-exchange-btn {
    font-weight: 600;
    border: none;
    transition: transform 0.1s ease, filter 0.15s ease;
}

.crypto-exchange-btn:hover,
.crypto-exchange-btn:focus {
    filter: brightness(0.95);
    transform: translateY(-1px);
}

.crypto-exchange-btn:active {
    transform: translateY(0);
}
</style>
